import React from 'react';
import classNames from 'classnames';
import Img from 'react-image';

class Photo extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			current: false,
		};

		console.log(this.props);

		this._goTo = this.props.goTo;
		this.props.addPhoto(this);
	}

	shouldComponentUpdate(nextState) {
		return nextState !== this.state;
	}

	goToThis = () =>
	{
		this._goTo(this.props.id);
	};

	getElementHtml()
	{
		return document.getElementById('photo' + this.props.id);
	}

	checkVisible()
	{
		let gallerie = document.getElementById("gallerie");
		let gallerieWidth = gallerie.offsetWidth;

		let elm = this.getElementHtml();
		if(elm)
			return Math.abs(elm.getBoundingClientRect().left + (elm.getBoundingClientRect().width / 2) - gallerieWidth / 2) < 20;

		return true;
	}

	getClassNames() {
		return classNames({
			'current': this.state.current,
			'photo': true
		});
	}

	render() {

		return (
			<div className={this.getClassNames()} id={'photo'+this.props.id} onClick={this.goToThis}>
				<div className="wrap">
					<div className="wrap">
						<Img
							src={this.props.data.medium}
							alt={this.props.key_album+' '+this.props.id}
							loader={
								<div className="spinner"></div>
							}
							unloader={
								"Erreur de chargement"
							}
						/>
						<br/>
						<a
							href={this.props.data.src}
							target="_blank"
						>
							<span className="hi-icon"><i className="icon-download"/></span>
						</a>
					</div>
				</div>
			</div>
		);
	}
}

export default Photo;



// WEBPACK FOOTER //
// ./src/components/Photo.js